const locationSeatsNeeded = {
  init() {
    this.select = document.querySelectorAll("select.f_number_of_seats");

    if (this.select.length) {
      this.addEvent();
    }
  },

  addEvent() {
    this.select.forEach((select) => {
      select.addEventListener("change", (e) => {
        const $this = e.currentTarget;
        const form = $this.closest("form");
        const value = $this.value;
        const options = this.getOptions(form);

        this.setAvailableOptions(options, value);
        this.resetSelect(form);
      });
    });
  },

  getOptions(form) {
    const options = form.querySelectorAll("[data-location_seats]");

    return options;
  },

  setAvailableOptions(options, value) {
    options.forEach((option) => {
      const availableSeats = option.dataset.location_seats;

      availableSeats.match(value)
        ? option.removeAttribute("disabled", true)
        : option.setAttribute("disabled", true);

      if (availableSeats === "") {
        option.removeAttribute("disabled", true);
      }

      if (value === "") {
        option.removeAttribute("disabled");
      }
    });
  },

  resetSelect(form) {
    const select = form.querySelector(".f_location_id");
    if(select) {
      const selectedOption = select.querySelector(`[value="${select.value}"]`);
  
      if (selectedOption && selectedOption.getAttribute("disabled")) {
        select.value = "";
      }
    }
  },
};

export default locationSeatsNeeded;
